// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-float-bottom[data-v-79794c0d]{position:sticky;position:-webkit-sticky;bottom:0;display:block;z-index:3;margin:-2.135vw}.c-float-bottom-background[data-v-79794c0d]{background:#fff;border-top:1px solid #ccc}", ""]);
// Exports
module.exports = exports;
